import {Icon} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {Tooltip} from '@material-ui/core'
import {CatalogViewActionButtons, ShowOnlyExpandedCardsToolbarButton, ShowExpandedCardsFirstToolbarButton, ToggleShowFilterChipsToolbarButton, ToggleAssortmentColumnViewButton} from '@modules/catalog'
import {useStores} from '@modules/VipLocalStore'
import {ui, useCatalog} from '@stores'
import {icons} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import {React, StyledProps, classNames, observer, Fragment} from '@api'
import * as css from './CatalogViewOptionButtons.css'

interface MyProps extends StyledProps {

}

interface MyProps {
  isInTopBar?: boolean
}

export const CatalogViewOptionButtons = observer<MyProps>(function CatalogViewOptionButtons({isInTopBar, className, ...props}) {
  const {
    catalogTab
  } = useStores()

  if (!catalogTab) return null

  const {
    filterChipsToolbar,
    catalog: {
      onCycleLevelOfDetail, isShowingAssortment,
      strings, groupBy, isShowingClientPDF, assortments,
      settings: {viewMode, levelOfDetail},
      catalogConfig,
      groupBy: {settings: {groupView}, isProductView},
      hasExpandedCatalogItems, collapseAllLocalLOD
    }
  } = catalogTab.storesToInject

  return <div  {...props} className={classNames(css.root, className)}>
    <CollectionTargetsToolbarButton/>
    {isInTopBar && !isProductView &&
	 <Fragment>
       {ui.settings.pivotView && groupBy.hierarchy.length > 1 && <PivotViewToggleButton/>}
	 </Fragment>}

    <ToggleAssortmentColumnViewButton/>

    {catalogConfig?.reportView && <ReportViewToggleButton/>}

    <CatalogViewActionButtons isInTopBar={isInTopBar}/>

      {!assortments.hideCatalogSpecificWidgets && !isShowingClientPDF && viewMode !== 'table' &&
       <PrimaryIconButton onClick={onCycleLevelOfDetail}
	                      tooltip={strings.levelOfDetail(levelOfDetail)}
	                      active={levelOfDetail == 1} //levelOfDetail === 1 ? 'zoom-out' : 'zoom-in'}
	                      icon={<Icon icon={levelOfDetail === 0 ? 'zoom-in' : 'zoom-out'}/>}/>
      }

      {!assortments.hideCatalogSpecificWidgets && groupView == 'card' && viewMode !== 'table' && <ShowExpandedCardsFirstToolbarButton/>}

      {!assortments.hideCatalogSpecificWidgets && viewMode !== 'table' && <Fragment>
		  <ShowOnlyExpandedCardsToolbarButton/>

		  <PrimaryIconButton
			  onClick={collapseAllLocalLOD}
			  tooltip={strings.collapseCards}
			  disabled={!hasExpandedCatalogItems}
			  icon={<Icon icon='collapse-all'/>}
		  />
	</Fragment>}
    {/* Move the filter toolbar button into the filter bar when it's active or the top bar when it's not
      Removed for YFTS-9918: (!isInTopBar || filterChipsToolbar.hide) &&
    */}
    {<ToggleShowFilterChipsToolbarButton/>}
  </div>
})

export const ReportViewToggleButton = observer(function ReportViewToggleButton() {
  const catalog = useCatalog(),
    active = catalog.settings.viewMode === 'report'

  return (
    <PrimaryIconButton
      tooltip={catalog.strings.reportView}
      icon={<Icon icon={icons.reportView}/>} active={active} onClick={() => catalog.settings.viewMode = active ? 'card' : 'report'}/>

  )
})

export const PivotViewToggleButton = observer(function PivotViewToggleButton() {
  const {strings, groupBy} = useCatalog()

  return (
    <PrimaryIconButton
      tooltip={strings.pivotView}
      icon={<Icon icon='pivot-table'/>} active={groupBy.pivotView} onClick={groupBy.togglePivotView}/>
  )
})

const CollectionTargetsToolbarButton = observer(function CollectionTargetsToolbarButton() {
  const {targetsToolbarConfig, onToggleShowTargetsToolbar, settings: {showTargetsToolbar}} = useCatalog()

  return !targetsToolbarConfig ? null :
         <PrimaryIconButton
           tooltip='Collection Targets'
           icon={<Icon icon='dollar'/>} onClick={onToggleShowTargetsToolbar} active={showTargetsToolbar}/>

})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/CatalogViewOptionButtons.tsx